export default "__VITE_ASSET__d7cb9407__"